module.exports = __webpack_public_path__ + "images/xl_ningxia.png?ea11ec6c2de1e378e05f3388320c3826";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_ningxia.png
// module id = 244
// module chunks = 1